import { apiFetch, Code, FetchReturn } from "../../lib/utils";

export interface TSupplier {
  Id: number;
}
export type S1GO_Customer ={
  id:number;
  customerId:string;
  customerOrgId:string;
  customerName:string;
  customerEmail:string;
}
const SupplierEndPoint = "/Suppliers";
// const Get = async (): Promise<TSupplier[]> => {
//   const response = await apiFetch(SupplierEndPoint);
//   const suppliers = await response.json();
//   return suppliers;
// }

// const Post = async (supplier: TSupplier): Promise<FetchReturn<TSupplier>> => {
//   try {
//     const result = await apiFetch(SupplierEndPoint, "POST", { ...supplier });
//     //return created object instead of local object
//     return { Code: Code.OK, Message: "Success", Content: supplier }
//   } catch (error) {
//     return { Code: Code.ADD_ERR, Message: "Något gick fel, kunde inte skapa granskning", Content: supplier };
//   }
// }

const GetSupplierDataByMonth = async (month: string): Promise<any[]> => {
  try {
    const response = await apiFetch(`${SupplierEndPoint}/api/supplierdata/${month}`);
    const supplierData = await response.json();
    // console.log("Supplier data:", supplierData);
    return supplierData;
  } catch (error) {
    console.error("Failed to fetch supplier data for month:", month, error);
    return [];
  }
};

const GetFullSupplierData = async (orgNumber: string, period: string): Promise<any> => {
  try {
    const response = await apiFetch(`${SupplierEndPoint}/api/supplierdata/full/${orgNumber}/${period}`);
    const supplierData = await response.json();
    // console.log("Full supplier data:", supplierData);
    return supplierData;
  } catch (error) {
    console.error("Failed to fetch full supplier data:", error);
    return null;
  }
};

// const GetInvoicesBySupplierOrgId = async (orgNumber: string): Promise<any[]> => {
//   try {
//     const response = await apiFetch(`${SupplierEndPoint}/api/invoices/${orgNumber}`);
//     const invoiceData = await response.json();
//     console.log("Invoice data:", invoiceData);
//     return invoiceData;
//   } catch (error) {
//     console.error("Failed to fetch invoice data:", error);
//     return [];
//   }
// };

// const GetWorstDiffByMax24 = async (orgNumber: string): Promise<any[]> => {
//   try {
//     const response = await apiFetch(`${SupplierEndPoint}/api/diffbymax24/${orgNumber}`);
//     const diffData = await response.json();
//     console.log("DiffByMax24 data:", diffData);
//     return diffData;
//   } catch (error) {
//     console.error("Failed to fetch DiffByMax24 data:", error);
//     return [];
//   }
// };

const GetDiffByMax24 = async (orgNumber: string): Promise<any[]> => {
  try {
    console.log("GetDiffByMax24", orgNumber);
    const response = await apiFetch(`${SupplierEndPoint}/api/alldiffbymax24/${orgNumber}`);
    const diffData = await response.json();
    return diffData;
  } catch (error) {
    console.error("Failed to fetch DiffByMax24 data:", error);
    return [];
  }
};

const GetAllReviewsBySupplierOrgId = async (orgNumber: string): Promise<any[]> => {
  try {
    const response = await apiFetch(`${SupplierEndPoint}/api/reviews/${orgNumber}`);
    const reviewsData = await response.json();
    return reviewsData;
  } catch (error) {
    console.error("Failed to fetch reviews data:", error);
    return [];
  }
};

const GetAllThresholds = async (): Promise<any> => {
  try {
    const response = await apiFetch(`/suppliers/api/thresholds/all`);
    const thresholds = await response.json();
    return thresholds; // Return all fetched thresholds
  } catch (error) {
    console.error("Failed to fetch all threshold data:", error);
    return null;
  }
}

// Post threshold values for the OrganizationThreshold table
const PostThresholdValues = async (OrgNr: string, LimitYellow: number, LimitRed: number): Promise<any> => {
  try {
    const response = await apiFetch(`${SupplierEndPoint}/api/thresholds/`, "POST", JSON.stringify({
      OrgNr, // OrgNr should be part of the payload
      LimitYellow,
      LimitRed
    }));

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.text();
    return result;
  } catch (error) {
    console.error("Failed to save threshold values:", error);
    return null;
  }
};

const GetMembersBySupplierOrgIdAndDate = async (supplierOrgId: string, startDate: string, endDate: string): Promise<any[]> => {
  try {
      const response = await apiFetch(`${SupplierEndPoint}/api/members/${supplierOrgId}/${startDate}/${endDate}`);
      const memberData = await response.json();
      console.log("Member data:", memberData);
      return memberData;
  } catch (error) {
      console.error("Failed to fetch member data for supplier:", supplierOrgId, "and date range:", startDate, endDate, error);
      return [];
  }
};
const GetAllMembers = async():Promise<S1GO_Customer[]> => {
  try {
    const response = await apiFetch(`${SupplierEndPoint}/api/members/getall`);
    const result = await response.json()
   const parsedResult = result.map((q:any) => {
      return {...q} as S1GO_Customer
    });
    return parsedResult;
  } catch (error) {
    console.error("Failed to fetch member list");
    return [];
  }
}
const GetLastContactedCustomMember = async(supplierOrgId:string):Promise<any[]> => {
  try {
     const response = await apiFetch(`${SupplierEndPoint}/api/custom-members/${supplierOrgId}`);
    const result = await response.json();
    console.log(result);
    return result; 
  } catch (error) {
    console.log(error)
    return [];
  }
}
export {
  // Get,
  // Post,
  GetSupplierDataByMonth,
  // GetInvoicesBySupplierOrgId,
  // GetWorstDiffByMax24,
  PostThresholdValues,
  GetAllThresholds,
  GetDiffByMax24,
  GetMembersBySupplierOrgIdAndDate,
  GetFullSupplierData,
  GetAllReviewsBySupplierOrgId,
  GetAllMembers,
  GetLastContactedCustomMember
}